import { render, staticRenderFns } from "./DeleteFolder.vue?vue&type=template&id=23866474&scoped=true&"
import script from "./DeleteFolder.vue?vue&type=script&lang=js&"
export * from "./DeleteFolder.vue?vue&type=script&lang=js&"
import style0 from "./DeleteFolder.vue?vue&type=style&index=0&id=23866474&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23866474",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23866474')) {
      api.createRecord('23866474', component.options)
    } else {
      api.reload('23866474', component.options)
    }
    module.hot.accept("./DeleteFolder.vue?vue&type=template&id=23866474&scoped=true&", function () {
      api.rerender('23866474', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/projects/documents/DeleteFolder.vue"
export default component.exports